'use strict';

import { User } from './User';
import { Ind } from '../Ind/Ind';
import { Entity } from '../Entity';

export class UserSmsThread extends Entity {
  protected id;
  protected user;
  protected ind;
  protected smsProvider;
  protected phoneNumber;
  protected direction;
  protected message;
  protected readStatus;
  protected threadDate;
  protected serviceId;
  protected displayDate;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.smsProvider = data.smsProvider;
    this.phoneNumber = data.phoneNumber;
    this.direction = data.direction;
    this.message = data.message;
    this.readStatus = data.readStatus;
    this.threadDate = data.threadDate;
    this.serviceId = data.serviceId;

    if (data.user) {
      const user = new User();
      user.hydrate(data.user);

      this.user = user;
    }

    if (data.ind) {
      const ind = new Ind();
      ind.hydrate(data.ind);

      this.ind = ind;
    }

    if (data.threadDate) {
      const displayDate = data.threadDate.date.split(' ')[0].split('-');
      this.displayDate = displayDate[1] + '/' + displayDate[2] + '/' + displayDate[0];
    }
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;
    return this;
  }

  public getUser() {
    return this.user;
  }

  public getInd() {
    return this.ind;
  }

  public getSmsProvider() {
    return this.smsProvider;
  }

  public setSmsProvider(smsProvider) {
    this.smsProvider = smsProvider;
    return this;
  }

  public getPhoneNumber() {
    return this.phoneNumber;
  }

  public setPhoneNumber(phoneNumber) {
    this.phoneNumber = phoneNumber;
    return this;
  }

  public getDirection() {
    return this.direction;
  }

  public setDirection(direction) {
    this.direction = direction;
    return this;
  }

  public getMessage() {
    return this.message;
  }

  public setMessage(message) {
    this.message = message;
    return this;
  }

  public getReadStatus() {
    return this.readStatus;
  }

  public setReadStatus(readStatus) {
    this.readStatus = readStatus;
    return this;
  }

  public getThreadDate() {
    return this.threadDate;
  }

  public setThreadDate(threadDate) {
    this.threadDate = threadDate;
    return this;
  }

  public getServiceId() {
    return this.serviceId;
  }

  public setServiceId(serviceId) {
    this.serviceId = serviceId;
    return this;
  }

  public getDisplayDate() {
    return this.displayDate;
  }
}
